import { Directive, Input } from '@angular/core';
import { BaseControlComponent } from './base-control.component';

@Directive({ selector: '[boiBaseCollectionComponent]' })
export class BaseCollectionComponent extends BaseControlComponent {
  @Input() public optionList: string;
  @Input() public availableOptions: Array<any>;
  @Input() public valueField = 'Code';
  @Input() public textField = 'Value';
}
